import { render, staticRenderFns } from "./StudentChartAlbum.vue?vue&type=template&id=e8448518&scoped=true"
import script from "./StudentChartAlbum.vue?vue&type=script&lang=js"
export * from "./StudentChartAlbum.vue?vue&type=script&lang=js"
import style0 from "./StudentChartAlbum.vue?vue&type=style&index=0&id=e8448518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8448518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8448518')) {
      api.createRecord('e8448518', component.options)
    } else {
      api.reload('e8448518', component.options)
    }
    module.hot.accept("./StudentChartAlbum.vue?vue&type=template&id=e8448518&scoped=true", function () {
      api.rerender('e8448518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chartStatistical/StudentChartAlbum.vue"
export default component.exports